import type { definitions, paths } from '@luxuryescapes/contract-svc-lux-loyalty'
import requestUtils from 'api/requestUtils'

type ClaimPath = paths['/api/lux-loyalty/claims/campaigns/{campaignId}/claim']['post']
type ClaimPayload = NonNullable<ClaimPath['requestBody']>['content']['application/json']
type ClaimResponse = ClaimPath['responses']['200']['content']['application/json']

export type ClaimActionResult = definitions['claimActionResultPresenter']
export type LoyaltyTierUpgradeClaimResult = ClaimResponse['result']

async function requestLoyaltyTierUpgradeClaim(campaignId: string, code: string): Promise<LoyaltyTierUpgradeClaimResult> {
  const response = await requestUtils.post<ClaimResponse, ClaimPayload>(
    `/api/lux-loyalty/claims/campaigns/${campaignId}/claim`,
    { code },
    { credentials: 'include', excludeBrand: true },
  )
  return response.result
}

export default requestLoyaltyTierUpgradeClaim
